'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _services = require('../actions/services');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(loadHealthGroups),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loadUnitsPerCountry),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(loadServices),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(loadSubServices),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(loadOffers),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(addOffer),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(editOffer),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(redeemCode),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(sagafetchServicesListPaginated),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(sagafetchServiceDetails),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(sagaDeleteService),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(sagaEditServiceDetails),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(fetchSearchedServices),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(addServices),
    _marked15 = /*#__PURE__*/_regenerator2.default.mark(sagaGetEntitySpecialtyServices),
    _marked16 = /*#__PURE__*/_regenerator2.default.mark(services);

function loadHealthGroups(_ref) {
  var headers = _ref.headers;
  var apiObj, healthGroupRes;
  return _regenerator2.default.wrap(function loadHealthGroups$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          apiObj = new _webUtils.API();
          _context.next = 4;
          return apiObj.get(_webUtils.Urls.offers.getHealthGroups, [].concat(headers));

        case 4:
          healthGroupRes = _context.sent;

          if (!_webUtils.STATUS.isSuccess(healthGroupRes.status)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return (0, _effects.put)((0, _services.loadHealthGroupsDone)(healthGroupRes.data));

        case 8:
          _context.next = 12;
          break;

        case 10:
          _context.next = 12;
          return (0, _effects.put)((0, _services.loadHealthGroupsFailed)('Failed to load health groups'));

        case 12:
          _context.next = 18;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](0);
          _context.next = 18;
          return (0, _effects.put)((0, _services.loadHealthGroupsFailed)('Failed to load health groups'));

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 14]]);
}

function loadUnitsPerCountry(_ref2) {
  var serviceId = _ref2.serviceId,
      headers = _ref2.headers;
  var apiObj, accountToken, unitsRes;
  return _regenerator2.default.wrap(function loadUnitsPerCountry$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          apiObj = new _webUtils.API();
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          _context2.next = 5;
          return apiObj.get(_webUtils.Urls.offers.getUnitsPerCountry + '?' + (0, _webUtils.jsonToQueryString)({ serviceId: serviceId }), [].concat(headers, [{
            key: 'x-vzt-authentication',
            value: accountToken
          }]));

        case 5:
          unitsRes = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(unitsRes.status)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return (0, _effects.put)((0, _services.loadUnitsPerCountryDone)(unitsRes.data));

        case 9:
          _context2.next = 13;
          break;

        case 11:
          _context2.next = 13;
          return (0, _effects.put)((0, _services.loadUnitsPerCountryFailed)('Failed to load units'));

        case 13:
          _context2.next = 19;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 19;
          return (0, _effects.put)((0, _services.loadUnitsPerCountryFailed)('Failed to load units'));

        case 19:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 15]]);
}

function loadServices(_ref3) {
  var serviceId = _ref3.serviceId,
      headers = _ref3.headers;
  var apiObj, accountToken, servicesRes;
  return _regenerator2.default.wrap(function loadServices$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          apiObj = new _webUtils.API();
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          _context3.next = 5;
          return apiObj.get(_webUtils.Urls.offers.getChildrenServices + '?' + (0, _webUtils.jsonToQueryString)({ serviceId: serviceId }), [].concat(headers, [{
            key: 'x-vzt-authentication',
            value: accountToken
          }]));

        case 5:
          servicesRes = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(servicesRes.status)) {
            _context3.next = 11;
            break;
          }

          _context3.next = 9;
          return (0, _effects.put)((0, _services.loadServicesDone)(servicesRes.data));

        case 9:
          _context3.next = 13;
          break;

        case 11:
          _context3.next = 13;
          return (0, _effects.put)((0, _services.loadServicesFailed)('Failed to load services'));

        case 13:
          _context3.next = 19;
          break;

        case 15:
          _context3.prev = 15;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 19;
          return (0, _effects.put)((0, _services.loadServicesFailed)('Failed to load services'));

        case 19:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 15]]);
}

function loadSubServices(_ref4) {
  var serviceId = _ref4.serviceId,
      headers = _ref4.headers;
  var apiObj, accountToken, subServicesRes;
  return _regenerator2.default.wrap(function loadSubServices$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          apiObj = new _webUtils.API();
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          _context4.next = 5;
          return apiObj.get(_webUtils.Urls.offers.getChildrenServices + '?' + (0, _webUtils.jsonToQueryString)({ serviceId: serviceId }), [].concat(headers, [{
            key: 'x-vzt-authentication',
            value: accountToken
          }]));

        case 5:
          subServicesRes = _context4.sent;

          if (!_webUtils.STATUS.isSuccess(subServicesRes.status)) {
            _context4.next = 11;
            break;
          }

          _context4.next = 9;
          return (0, _effects.put)((0, _services.loadSubServicesDone)(subServicesRes.data));

        case 9:
          _context4.next = 13;
          break;

        case 11:
          _context4.next = 13;
          return (0, _effects.put)((0, _services.loadSubServicesFailed)('Failed to load sub-services'));

        case 13:
          _context4.next = 19;
          break;

        case 15:
          _context4.prev = 15;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 19;
          return (0, _effects.put)((0, _services.loadSubServicesFailed)('Failed to load sub-services'));

        case 19:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 15]]);
}

function loadOffers(_ref5) {
  var entityKey = _ref5.entityKey,
      accountKey = _ref5.accountKey,
      branckKey = _ref5.branckKey,
      headers = _ref5.headers;
  var apiObj, offersRes;
  return _regenerator2.default.wrap(function loadOffers$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          apiObj = new _webUtils.API();
          _context5.next = 4;
          return apiObj.get(_webUtils.Urls.offers.getOffers + '?' + (0, _webUtils.jsonToQueryString)({ entityKey: entityKey, branckKey: branckKey, accountKey: accountKey }), [{
            key: 'languageId',
            value: 1
          }].concat(headers));

        case 4:
          offersRes = _context5.sent;

          if (!_webUtils.STATUS.isSuccess(offersRes.status)) {
            _context5.next = 10;
            break;
          }

          _context5.next = 8;
          return (0, _effects.put)((0, _services.loadOffersDone)(offersRes.data));

        case 8:
          _context5.next = 12;
          break;

        case 10:
          _context5.next = 12;
          return (0, _effects.put)((0, _services.loadOffersFailed)('Failed to load offers'));

        case 12:
          _context5.next = 18;
          break;

        case 14:
          _context5.prev = 14;
          _context5.t0 = _context5['catch'](0);
          _context5.next = 18;
          return (0, _effects.put)((0, _services.loadOffersFailed)('Failed to load offers'));

        case 18:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[0, 14]]);
}

function addOffer(_ref6) {
  var data = _ref6.data;
  var accountToken, accountKey, Headers, apiObj, offerRes;
  return _regenerator2.default.wrap(function addOffer$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          accountKey = (0, _webUtils.decodeJwtToken)(accountToken).payLoad.unique_name;
          _context6.prev = 2;
          Headers = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }, {
            key: 'accountkey',
            value: accountKey
          }];
          apiObj = new _webUtils.API();
          _context6.next = 7;
          return apiObj.post(_webUtils.Urls.offers.addOffer, _extends({}, data), Headers);

        case 7:
          offerRes = _context6.sent;

          if (!_webUtils.STATUS.isSuccess(offerRes.status)) {
            _context6.next = 13;
            break;
          }

          _context6.next = 11;
          return (0, _effects.put)((0, _services.addOfferDone)(offerRes.data));

        case 11:
          _context6.next = 15;
          break;

        case 13:
          _context6.next = 15;
          return (0, _effects.put)((0, _services.addOfferFailed)('Failed to add offer'));

        case 15:
          _context6.next = 21;
          break;

        case 17:
          _context6.prev = 17;
          _context6.t0 = _context6['catch'](2);
          _context6.next = 21;
          return (0, _effects.put)((0, _services.addOfferFailed)('Failed to add offer'));

        case 21:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[2, 17]]);
}

function editOffer(_ref7) {
  var data = _ref7.data;
  var accountToken, accountKey, Headers, apiObj, offerRes;
  return _regenerator2.default.wrap(function editOffer$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          accountKey = (0, _webUtils.decodeJwtToken)(accountToken).payLoad.unique_name;
          _context7.prev = 2;
          Headers = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }, {
            key: 'accountkey',
            value: accountKey
          }];
          apiObj = new _webUtils.API();
          _context7.next = 7;
          return apiObj.post(_webUtils.Urls.offers.editOffer, _extends({}, data), Headers);

        case 7:
          offerRes = _context7.sent;

          if (!_webUtils.STATUS.isSuccess(offerRes.status)) {
            _context7.next = 13;
            break;
          }

          _context7.next = 11;
          return (0, _effects.put)((0, _services.editOfferDone)(offerRes.data));

        case 11:
          _context7.next = 15;
          break;

        case 13:
          _context7.next = 15;
          return (0, _effects.put)((0, _services.editOfferFailed)('Failed to edit offer'));

        case 15:
          _context7.next = 21;
          break;

        case 17:
          _context7.prev = 17;
          _context7.t0 = _context7['catch'](2);
          _context7.next = 21;
          return (0, _effects.put)((0, _services.editOfferFailed)('Failed to edit offer'));

        case 21:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[2, 17]]);
}

function redeemCode(_ref8) {
  var code = _ref8.code,
      entityKey = _ref8.entityKey,
      headers = _ref8.headers;
  var apiObj, redeemedRes;
  return _regenerator2.default.wrap(function redeemCode$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          apiObj = new _webUtils.API();
          _context8.next = 3;
          return apiObj.post(_webUtils.Urls.offers.redeemCode + '?' + (0, _webUtils.jsonToQueryString)({ code: code, entityKey: entityKey }), null, [{
            key: 'languageId',
            value: 1
          }].concat(headers));

        case 3:
          redeemedRes = _context8.sent;

          if (!_webUtils.STATUS.isSuccess(redeemedRes.status)) {
            _context8.next = 9;
            break;
          }

          _context8.next = 7;
          return (0, _effects.put)((0, _services.redeemCodeDone)(redeemedRes.data));

        case 7:
          _context8.next = 11;
          break;

        case 9:
          _context8.next = 11;
          return (0, _effects.put)((0, _services.redeemCodeFailed)(redeemedRes));

        case 11:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

/** Services module */
function sagafetchServicesListPaginated(action) {
  var servicesListAPI, authToken, header, response;
  return _regenerator2.default.wrap(function sagafetchServicesListPaginated$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          servicesListAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'countryId',
            value: '' + action.payload.countryId
          }, {
            key: 'languageId',
            value: '' + action.payload.languageId
          }];
          _context9.next = 5;
          return servicesListAPI.get(_webUtils.Urls.getEntity + '?pageIndex=' + action.payload.Page + '&pageSize=' + action.payload.PageSize + '&keyword=' + (action.payload.KeyWord ? action.payload.KeyWord : '') + '&branchKeys=' + action.payload.selectedBranches.join(',') + '&accountKeys=' + action.payload.selectedDoctors.join(',') + '&insuranceKeys=' + action.payload.selectedInsurances.join(','), header);

        case 5:
          response = _context9.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context9.next = 11;
            break;
          }

          _context9.next = 9;
          return (0, _effects.put)((0, _services.fetchServicesListSuccess)(_extends({}, response.response, action.payload)));

        case 9:
          _context9.next = 13;
          break;

        case 11:
          _context9.next = 13;
          return (0, _effects.put)((0, _services.fetchServicesListFail)(_extends({}, action.payload)));

        case 13:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function sagafetchServiceDetails(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function sagafetchServiceDetails$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'countryId',
            value: '' + action.payload.countryId
          }, {
            key: 'languageId',
            value: '' + action.payload.languageId
          }];
          _context10.next = 5;
          return api.get(_webUtils.Urls.getEntity + '/' + action.payload.entityServiceCountryKey, header);

        case 5:
          response = _context10.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context10.next = 11;
            break;
          }

          _context10.next = 9;
          return (0, _effects.put)((0, _services.fetchServiceDetailsSuccess)(_extends({}, response.response, action.payload)));

        case 9:
          _context10.next = 13;
          break;

        case 11:
          _context10.next = 13;
          return (0, _effects.put)((0, _services.fetchServiceDetailsFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function sagaDeleteService(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function sagaDeleteService$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context11.next = 5;
          return api.delete(_webUtils.Urls.getEntity + '/' + action.payload.entityServiceCountryKey, header);

        case 5:
          response = _context11.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context11.next = 11;
            break;
          }

          _context11.next = 9;
          return (0, _effects.put)((0, _services.deleteServiceSuccess)(_extends({}, response.response, action.payload)));

        case 9:
          _context11.next = 13;
          break;

        case 11:
          _context11.next = 13;
          return (0, _effects.put)((0, _services.deleteServiceFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function sagaEditServiceDetails(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function sagaEditServiceDetails$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'countryId',
            value: '' + action.payload.countryId
          }, {
            key: 'languageId',
            value: '' + action.payload.languageId
          }];
          _context12.next = 5;
          return api.put(_webUtils.Urls.getEntity + '/' + action.payload.entityServiceCountryKey, action.payload.newServiceDetails, header);

        case 5:
          response = _context12.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context12.next = 11;
            break;
          }

          _context12.next = 9;
          return (0, _effects.put)((0, _services.editServiceSuccess)(_extends({}, response.response, action.payload)));

        case 9:
          _context12.next = 13;
          break;

        case 11:
          _context12.next = 13;
          return (0, _effects.put)((0, _services.editServiceFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function fetchSearchedServices(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function fetchSearchedServices$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'countryid',
            value: '' + action.payload.countryId
          }, {
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context13.next = 5;
          return api.get(_webUtils.Urls.getServices + '?keyword=' + action.payload.keyWord + '&pageIndex=1&pageSize=10', header);

        case 5:
          response = _context13.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context13.next = 11;
            break;
          }

          _context13.next = 9;
          return (0, _effects.put)((0, _services.searchServiceSuccess)(_extends({}, response.response)));

        case 9:
          _context13.next = 13;
          break;

        case 11:
          _context13.next = 13;
          return (0, _effects.put)((0, _services.searchServiceFail)(_extends({}, action.payload)));

        case 13:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function addServices(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function addServices$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'countryId',
            value: '' + action.payload.countryId
          }, {
            key: 'languageId',
            value: '' + action.payload.languageId
          }];
          _context14.next = 5;
          return api.post('' + _webUtils.Urls.getEntity, action.payload.newServiceDetails, header);

        case 5:
          response = _context14.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context14.next = 11;
            break;
          }

          _context14.next = 9;
          return (0, _effects.put)((0, _services.addServiceSuccess)(_extends({}, response.response)));

        case 9:
          _context14.next = 13;
          break;

        case 11:
          _context14.next = 13;
          return (0, _effects.put)((0, _services.addServiceFail)(_extends({}, response.response)));

        case 13:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function sagaGetEntitySpecialtyServices(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function sagaGetEntitySpecialtyServices$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'countryId',
            value: '' + action.payload.countryId
          }];
          _context15.next = 5;
          return api.get(_webUtils.Urls.getEntity + '/getEntityAndSpecialtyServices?accountKey=' + action.payload.accountKey + '&branchKey=' + action.payload.branckKey + '&specialtyCountryKey=' + action.payload.specialtyCountryKey + '&insuranceCountryKey=' + action.payload.insuranceCountryKey, header);

        case 5:
          response = _context15.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context15.next = 11;
            break;
          }

          _context15.next = 9;
          return (0, _effects.put)((0, _services.getEntitySpecialtyServicesSuccess)(_extends({}, response.response, action.payload)));

        case 9:
          _context15.next = 13;
          break;

        case 11:
          _context15.next = 13;
          return (0, _effects.put)((0, _services.getEntitySpecialtyServicesFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function services() {
  return _regenerator2.default.wrap(function services$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeEvery)(_services.SERVICES.HEALTH_GROUPS.LOAD, loadHealthGroups);

        case 2:
          _context16.next = 4;
          return (0, _effects.takeEvery)(_services.SERVICES.SERVICES.LOAD, loadServices);

        case 4:
          _context16.next = 6;
          return (0, _effects.takeEvery)(_services.SERVICES.SUB_SERVICES.LOAD, loadSubServices);

        case 6:
          _context16.next = 8;
          return (0, _effects.takeEvery)(_services.SERVICES.OFFER.LOAD_ALL, loadOffers);

        case 8:
          _context16.next = 10;
          return (0, _effects.takeEvery)(_services.SERVICES.OFFER.ADD, addOffer);

        case 10:
          _context16.next = 12;
          return (0, _effects.takeEvery)(_services.SERVICES.OFFER.EDIT, editOffer);

        case 12:
          _context16.next = 14;
          return (0, _effects.takeEvery)(_services.SERVICES.CODE.REDEEM, redeemCode);

        case 14:
          _context16.next = 16;
          return (0, _effects.takeEvery)(_services.SERVICES.UNITS.LOAD, loadUnitsPerCountry);

        case 16:
          _context16.next = 18;
          return (0, _effects.takeEvery)(_services.SERVICES.SERVICES_LIST.FETCH, sagafetchServicesListPaginated);

        case 18:
          _context16.next = 20;
          return (0, _effects.takeEvery)(_services.SERVICES.GET_SERVICE_DETAILS.FETCH, sagafetchServiceDetails);

        case 20:
          _context16.next = 22;
          return (0, _effects.takeEvery)(_services.SERVICES.SEARCH.LOAD, fetchSearchedServices);

        case 22:
          _context16.next = 24;
          return (0, _effects.takeEvery)(_services.SERVICES.EDIT_SERVICE_DETAILS.SUBMIT, sagaEditServiceDetails);

        case 24:
          _context16.next = 26;
          return (0, _effects.takeEvery)(_services.SERVICES.ADD_SERVICE.LOAD, addServices);

        case 26:
          _context16.next = 28;
          return (0, _effects.takeEvery)(_services.SERVICES.GET_ENTITY_SPECIALTY_SERVICE.FETCH, sagaGetEntitySpecialtyServices);

        case 28:
          _context16.next = 30;
          return (0, _effects.takeEvery)(_services.SERVICES.DELETE_SERVICE.SUBMIT, sagaDeleteService);

        case 30:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

exports.default = services;
module.exports = exports['default'];